import { LogoWhatsapp, Button } from 'components'

const stgNumber = 553196613445 // (Homologação)
const prdNumber = 553183264442 // (Produção)

export const WhatsappButton = (vacancy: { title: string; id: number }) => {
  const handleClick = () => {
    const phone = process.env.NODE_ENV === 'production' ? prdNumber : stgNumber
    const text = `Olá, desejo me candidatar na ${vacancy.title} com ID ${vacancy.id}`
    const url = `https://wa.me/${phone}?text=${encodeURI(text)}`

    window.open(url, '_blank')
  }

  return (
    <Button
      onClick={handleClick}
      className="items-center h-10 sm:h-auto gap-1.5 px-4 text-primary-700 bg-transparent hover:bg-primary/10"
    >
      <LogoWhatsapp />
      Candidatura pelo WhatsApp
    </Button>
  )
}
